import React from 'react';
import PropTypes from 'prop-types';

import Button from '../Button';
import Icon from '../Icon';
import ChevronRight from '../../svg/icons/chevron-right.svg';
import TranslationProvider, { getTranslation } from '../../providers/TranslationProvider';
import { useAnalytics } from '../AnalyticsProvider';
import { getPageContext, openExternalUrl } from '../../utils';

import './GdaBanner.scss';

const GdaBanner = ({
  icon, bannerText, translationKey, gdaIconWidth, gdaIconHeight, onClick,
}) => {
  const Analytics = useAnalytics();
  const context = getPageContext(window.location.pathname);

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      Analytics?.event('click gda link', {
        context,
        value: 'venue banner',
      });

      openExternalUrl('https://resy.com/global-dining-access#platinumoffer');
    }
  };
  return (
    <Button
      className="GdaBanner"
      aria-label={getTranslation({
        translationKey,
        fallback: bannerText,
      })}
      onClick={handleClick}
      variant="gda-banner"
    >
      <Icon
        className="GdaBanner__badge"
        component={icon}
        name="GdaBanner-badge"
        height={gdaIconHeight ?? '45px'}
        width={gdaIconWidth ?? '40px'}
        aria-label={getTranslation({
          translationKey: 'gda_icon',
          fallback: 'Global Dining Access icon',
        })}
      />
      <TranslationProvider translationKey={translationKey}>
        <div className="GdaBanner__text">{bannerText}</div>
      </TranslationProvider>
      <Icon
        className="GdaBanner__right"
        component={ChevronRight}
        name="GdaBanner-right"
        height="22px"
        width="22px"
      />
    </Button>
  );
};

GdaBanner.propTypes = {
  icon: PropTypes.func.isRequired,
  bannerText: PropTypes.string.isRequired,
  translationKey: PropTypes.string.isRequired,
  gdaIconWidth: PropTypes.string,
  gdaIconHeight: PropTypes.string,
  onClick: PropTypes.func,
};

GdaBanner.defaultProps = {
  onClick: undefined,
  gdaIconWidth: undefined,
  gdaIconHeight: undefined,
};

export default GdaBanner;
